module.exports = __webpack_public_path__ + "img/noData_v2.6e9f0005.png";